"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconConfirmFields = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M69 33.12H1V18h68zM3.81 30.36h62.38v-9.59H3.81zM69 52H1V36.88h68zM3.81 49.23h62.38v-9.59H3.81z"
  }), _react["default"].createElement("path", {
    d: "M60.16 28.41a1 1 0 0 1-.74-.31l-1.76-1.76a1 1 0 1 1 1.48-1.48l1 1L63 23a1 1 0 1 1 1.48 1.48l-3.6 3.6a1 1 0 0 1-.72.33zM62.94 47.3a1 1 0 0 1-.74-.3l-3.6-3.6a1 1 0 0 1 1.48-1.48l3.6 3.6a1 1 0 0 1-.74 1.78z"
  }), _react["default"].createElement("path", {
    d: "M59.34 47.3a1 1 0 0 1-.74-1.78l3.6-3.6a1 1 0 0 1 1.48 1.48l-3.6 3.6a1 1 0 0 1-.74.3z"
  })),
  height: undefined,
  width: undefined
});
IconConfirmFields.displayName = 'IconConfirmFields';
var _default = IconConfirmFields;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/confirm-fields.js
// module id = 565
// module chunks = 0